import { Link } from '@mui/material';
import React from 'react';

export function ExternalLink({
  href,
  children,
  ...props
}: {
  href: string;
  children: React.ReactNode;
}) {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
      }}
      color={'primary'}
      {...props}
    >
      <>{children}</>
    </Link>
  );
}
